/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {useCallback, useState} from 'react';
import {useAgentsAPI} from './useAgentsAPI';
import {type APIParams, METHODS} from '../../../hooks/abstractions/useTrusstedAgent';
import {AGENTS_API_EVENT_NAMES} from '../../../types/agents-api';

export const useDeleteAgent = () => {
  const agentsAPI = useAgentsAPI();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const del = useCallback(
    async (agentId: string) => {
      setIsLoading(true);
      setError(null);

      try {
        await agentsAPI({
          eventName: AGENTS_API_EVENT_NAMES.DeleteAgent,
          methodName: METHODS.POST,
          params: {agentId},
        } as APIParams);

        setIsLoading(false);
        return true;
      } catch (err) {
        setIsLoading(false);
        setError('Failed to delete agent');
        return Promise.reject(err);
      }
    },
    [agentsAPI],
  );

  return {
    isLoading,
    error,
    del,
  };
};
